import React, { useState } from 'react';
import cn from 'classnames';

import { Button, Modal } from '@components/common';

import { Icons } from '@icons/icons';

import { IMovePortalFilesDTO } from '@interfaces/portal/dto/foldersManagementDTO';
import { IPortalFolder } from '@interfaces/portal/folders';

import SelectFolderModal from '../SelectFolderModal';

import styles from './MoveFilesForm.module.scss';

interface IMoveFilesFormProps {
	selectedFolder?: IPortalFolder;
	handleMoveFiles: (data: IMovePortalFilesDTO) => void;
	filesIdsForMove: string[] | null;
	closeMoveFilesForm: () => void;
	projectId: string;
}

const SELECT_FOLDER_BUTTON_TEXT = 'Select folder/subfolder';

const MoveFilesForm = ({
	selectedFolder,
	handleMoveFiles,
	filesIdsForMove,
	projectId,
	closeMoveFilesForm,
}: IMoveFilesFormProps) => {
	const [isSelectFolderModal, setIsSelectFolderModal] = useState(false);
	const [destinationFolder, setDestinationFolder] = useState<IPortalFolder | null>(null);

	const openSelectFolderModal = () => setIsSelectFolderModal(true);

	const closeSelectFolderModal = () => setIsSelectFolderModal(false);

	const onSelectFolder = (selectedFolder: IPortalFolder | null) => {
		setDestinationFolder(selectedFolder);
		closeSelectFolderModal();
	};

	const handleProceed = () => {
		if (!selectedFolder?.id || !destinationFolder?.id || !filesIdsForMove) {
			return;
		}

		handleMoveFiles({
			folderId: destinationFolder.id,
			ids: filesIdsForMove,
		});

		closeMoveFilesForm();
	};

	const isProceedDisabled = !(selectedFolder?.id && destinationFolder?.id);

	return (
		<>
			<div className={styles.folderInputsContainer}>
				<div className={styles.folderInput}>
					<div className={styles.label}>
						Current Folder
					</div>
					<div className={styles.folderNameContainer}>
						<div className={styles.icon}>
							{selectedFolder?.hasContent ? Icons.folderIcon() : Icons.folderEmpty()}
						</div>
						<div className={styles.folderName}>
							{selectedFolder?.name || ''}
						</div>
					</div>
				</div>
				<div className={styles.folderInput}>
					<div className={cn(styles.label, styles.required)}>
						Destination Folder
					</div>
					{destinationFolder
						&& <div className={styles.folderNameContainer}>
							<div className={styles.icon}>
								{destinationFolder?.hasContent ? Icons.folderIcon() : Icons.folderEmpty()}
							</div>
							<div className={styles.folderName}>
								{destinationFolder?.name || ''}
							</div>
						</div>
					}
					<div
						className={styles.selectFolderButton}
						onClick={openSelectFolderModal}
					>
						{SELECT_FOLDER_BUTTON_TEXT}
					</div>
				</div>
			</div>
			<div className={styles.buttons}>
				<Button
					onClick={closeMoveFilesForm}
					text='Cancel'
					withoutBackground
				/>
				<Button
					disabled={isProceedDisabled}
					onClick={handleProceed}
					text='Proceed'
				/>
			</div>
			<Modal
				isOpen={isSelectFolderModal}
				isScrollableContent
				onClose={closeSelectFolderModal}
				title={SELECT_FOLDER_BUTTON_TEXT}
				width='400px'
			>
				<SelectFolderModal
					disabledFolderId={selectedFolder?.id}
					projectId={projectId}
					selectFolder={onSelectFolder}
				/>
			</Modal>
		</>
	);
};

export default MoveFilesForm;
